<script lang="ts">
	import { cfgEventThemeCdnPath, cfgToThemeCdnPath, isEventAssetEnabled } from '@infinitro/config';
	import { t, Verbiage } from '@infinitro/content';
	import { CloseIcon } from '@infinitro/icons';
	import type { Tab } from '../types';

	export let onClose: () => void = () => {};
	export let activeTab: Tab = 'home';

	$: useEventLogo = isEventAssetEnabled('customLogo');
	$: logoPath = useEventLogo
		? cfgEventThemeCdnPath('customlogo.png')
		: cfgToThemeCdnPath('/misc/logo.svg');
</script>

<header class="widget-header" class:widget-header-transparent={activeTab === 'home'}>
	<div class="brand-logo" class:brand-logo-inverted={activeTab !== 'home'}>
		<img src={logoPath} alt={$t(Verbiage.site_logo_alt, 'alts')} />
	</div>

	<button
		class="header-action"
		class:header-action-on-light={activeTab !== 'home'}
		type="button"
		aria-label={$t(Verbiage.close)}
		on:click={onClose}
	>
		<CloseIcon />
	</button>
</header>

<style>
	.widget-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
}

	.widget-header-transparent {
		background-image: none;
		background-color: transparent;
	}

	.brand-logo {
		display: flex;
		min-width: 0px;
		flex: 1 1 0%;
		align-items: center;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.brand-logo img {
		height: 100%;
		max-height: 28px;
		width: auto;
		max-width: 88px;
		-o-object-fit: contain;
		   object-fit: contain;
}

	.brand-logo-inverted img {
		--tw-invert: invert(100%);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

	.header-action {
		display: flex;
		height: 1.75rem;
		width: 1.75rem;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		border-radius: 9999px;
		padding: 0.5rem;
		color: var(--color-text-100);
		background-color: rgba(var(--color-text-100-rgb), 0.12);
}

	/* White header (messages / help): dark icon + visible chip */
	.header-action-on-light {
		color: var(--color-text-900);
		background-color: rgba(var(--color-background-900-rgb), 0.12);
	}

	.header-action-on-light:hover {
		background-color: rgba(var(--color-background-900-rgb), 0.18);
	}

	.header-action-on-light :global(svg) {
		color: inherit;
		filter: brightness(0.35);
	}

	.header-action-on-light :global(img) {
		filter: brightness(0.35);
	}

	.header-action-on-light :global(path),
	.header-action-on-light :global(circle),
	.header-action-on-light :global(rect) {
		fill: currentColor;
	}

	.header-action-on-light :global(line),
	.header-action-on-light :global(polyline) {
		stroke: currentColor;
	}

	.header-action :global(svg),
	.header-action :global(img) {
		height: 100%;
		width: 100%;
}
</style>
